import { render, staticRenderFns } from "./VMainNavItem.vue?vue&type=template&id=35fd7db2&"
import script from "./VMainNavItem.vue?vue&type=script&lang=js&"
export * from "./VMainNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports